const defaultLanguage = 'he';
const languages = ['he', 'en'];

module.exports = {
  languages,
  defaultLanguage,
};